<template>
    <div class="container">
      <div id="printMe" style="width: 100%;">
        <div style="display: -webkit-flex;display: flex;flex-direction: row; border-bottom: 1px solid #000; padding-bottom: 30px;">
          <img style="width: 77px; height: 77px; padding: 5px 10px;" src="@/assets/sxlogo.png"/>
          <div style="color: #AAA; display: -webkit-flex;display: flex;flex-direction: column;flex: 1;">
            <div
              style="display: -webkit-flex;display: flex;flex-direction: row; justify-content: space-between;font-size: 30px; font-family: SimHei,serif;">
              <span>杭</span>
              <span>州</span>
              <span>视</span>
              <span>芯</span>
              <span>科</span>
              <span>技</span>
              <span>有</span>
              <span>限</span>
              <span>公</span>
              <span>司</span>
            </div>
            <div style="text-align: center;font-size: 24px; margin-top: 10px;">Hangzhou SHIXIN Technology CO., LTD.</div>
            <div style="display: -webkit-flex;display: flex; flex-direction: row; margin: 15px 0 15px;">
              <span style="flex: 1;">地址：杭州市黄姑山路9号2幢309室</span>
              <span style="flex: 1;">邮编：310012 </span>
            </div>
            <div style="display: -webkit-flex;display: flex; flex-direction: row; margin: 5px 0 15px;">
              <span style="flex: 1;">电话：0086-571-88210511</span>
              <span style="flex: 1;">传真：0086-571-88213722</span>
            </div>
          </div>
        </div>
        <div style="display: -webkit-flex;display: flex; flex-direction: row; margin: 5px 0;">
          <span style="flex: 1.8;">  </span>
          <span style="flex: 1;"> 表单编号：Q/LS-RP-003 V1.0</span>
        </div>
        <div style="position: relative; text-align: center; margin-top: 25px;">
          <span style="font-size: 24px;">杭 州 视 芯 发 货 单</span>
        </div>
        <div style="display: -webkit-flex;display: flex; flex-direction: row; margin: 30px 0 15px;">
          <span style="flex: 1;">出货日期: {{deliveryDate}}</span>
          <span style="flex: 1.5;">收货单位: {{detail.customer && detail.customer.customerName}}</span>
          <span style="flex: 1;">(SN单号): {{detail.productOrderNo}}</span>
        </div>
        <table border="1" cellspacing="0" class="table" style="width: 100%;">
          <thead>
            <tr style="height: 40px;">
              <th rowspan="1">货品名称</th>
              <th rowspan="1">计价只数</th>
              <th rowspan="1">总只数</th>
              <th rowspan="1">订单号</th>
              <th rowspan="1">料号</th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 30px; text-align: center;" v-for="(item, index) in prodStores" :key="index">
              <th rowspan="1">{{item.productName}}</th>
              <th rowspan="1">{{item.count}}</th>
              <th rowspan="1">{{item.count}}</th>
              <th rowspan="1">{{item.incoOrderNo}}</th>
              <th rowspan="1">{{item.endDevicen}}</th>
            </tr>
            <tr style="height: 30px;">
              <td colspan="3" style="text-align: center;">总计:</td>
              <td colspan="7">一共{{boxCount}}箱,总数为: {{passCount + failCount}}</td>
            </tr>
          </tbody>
        </table>
        <div style="margin: 30px 10px 0;">
          P/N:
        </div>
        <div style="margin: 20px 10px 0;">
          运输方式: {{expressageTypeVal(detail.expressageType)}}
        </div>
        <div style="margin: 20px 10px 0;">
          备注: {{detail.comment}}
        </div>
        <div style="display: -webkit-flex;display: flex; flex-direction: row; margin: 50px 150px 15px;">
          <span style="flex: 1;">收货人：{{contact}}</span>
          <span style="flex: 1;">发货人：李敏</span>
        </div>

        <div style="text-align: center;">
          当您收到上述电路时，烦请立即回签，谢谢合作！
        </div>
        <div style="text-align: center;">
          电话：0571-86626379      传真：0571-86620202
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import printJS from 'print-js';
import { prodOrderDetailById } from '@/api/prodOrder';
import { expressageTypes } from '@/utils/defines';

const FAIL_BIN = 8;

export default {
  name: 'tpInvoice',
  data() {
    const expressageTypesObj = {};
    let expressageTypesItem;
    for (const key in expressageTypes) {
      if (Object.prototype.hasOwnProperty.call(expressageTypes, key)) {
        expressageTypesItem = expressageTypes[key];
        expressageTypesObj[expressageTypesItem.val] = expressageTypesItem.explain;
      }
    }
    return {
      tableData: [{}],
      detail: {},
      prodStores: [],
      FAIL_BIN,
      passCount: 0,
      failCount: 0,
      expressageTypesObj,
      boxCount: 0,
      prodInfos: [],
      customer:{},
    };
  },
  mounted() {
    this.prodOrderDetailById();
  },
  computed: {
    deliveryDate() {
      return moment.utc().local().format('YYYY.M.D');
    },
  },
  methods: {
    async prodOrderDetailById() {
      const {
        productOrderNo,
      } = this.$route.params;
      try {
        const res = await prodOrderDetailById({ productOrderNo });
        const {
          data,
        } = res;
        const {
          detail,
        } = data;
        this.prodStores = [];
        const prodStores = detail.prodStores;
        this.contact = detail.contact;
        this.passCount = 0;
        this.failCount = 0;
        let length, info, count, index = 0;
        for (const row of prodStores) {
          info = row.info;
          count = row.count;
          length = info.length;
          index++;
          for (let i = 0; i < length; i++) {
            if (i === 0) {
              this.prodStores.push({
                ...row,
                ...info[i],
                rowspan: length,
                allCount: count,
                index,
              });
            } else {
              this.prodStores.push({
                ...row,
                ...info[i],
                allCount: count,
              });
            }
          }
          if (row.binLevel === FAIL_BIN) {
            this.failCount += row.count;
          } else {
            this.passCount += row.count;
          }
        }
        this.boxCount = prodStores.length;
        this.detail = detail;
        this.$nextTick(() => {
          this.onPrint();
        });
      } catch (e) {
        // do nothing.
      }
    },
    onPrint() {
      const style = '@page { size: auto; } @media print { }';
      printJS({
        printable: 'printMe', // 要打印内容的id
        type: 'html',
        style,
        scanStyles: false,
      });
    },
    orderNoVal(row) {
      const {
        incoOrdersDetail
      } = row;
      const {
        incoOrder
      } = incoOrdersDetail;
      if (!incoOrder) {
        return '';
      }
      return `${incoOrder.incoOrderNo}`;
    },
    expressageTypeVal(val) {
      return this.expressageTypesObj[`${val}`];
    },
  },
};
</script>

<style scoped>
  .container {
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    color: black;
    padding: 0;
  }
</style>
